import { useEffect } from 'react';

import { oidcLoginFeature } from 'src/shared/app/feature/settings/featureSettings';
import useEventFeatures from 'src/shared/domain/event/hook/useEventFeatures';

export default function useOpenidConnectTokenRefresh() {
  // This allows the OIDC token to be refreshed before it expires

  const testTimeout10min = () => {
    // eslint-disable-next-line no-console
    console.log('testTimeout10min', new Date());
    setTimeout(testTimeout10min, 10 * 60 * 1000);
  };

  const testTimeout60min = () => {
    // eslint-disable-next-line no-console
    console.log('testTimeout60min', new Date());
    setTimeout(testTimeout10min, 60 * 60 * 1000);
  };

  const refreshToken = () => {
    fetch('/auth/refresh', { method: 'POST' })
      .then((response) => {
        if (response.status === 200) {
          response.json().then((data) => {
            const { expiresIn } = data;
            // We refresh the token 5 minutes before it expires
            setTimeout(refreshToken, (expiresIn - 15) * 1000);
          });
        }
      })
      .catch((error) => {
        // Can’t refresh the token,
        // once the access token expires, the user will be redirected to the login page
      });
  };

  const features = useEventFeatures();
  const { [oidcLoginFeature]: oidcFeature } = features;

  useEffect(() => {
    if (oidcFeature) {
      testTimeout10min();
      testTimeout60min();
      refreshToken();
    }
  }, [oidcLoginFeature]);
}
